import { googleAuthApi } from "@/api/auth-api";
import { Toast } from "antd-mobile";
import { saveToken } from "./token-util";

export const doGoogleLogin = async ({
  idToken,
  invit,
  translate,
}: {
  idToken: string;
  translate: (key: string) => string;
  invit?: string;
}) => {
  if (!idToken) {
    Toast.show('Google auth error');
    return;
  }

  try {
    const res = await googleAuthApi({ idToken, invit });
    if (res.ok) {
      const userInfo = res.data;
      // 保存 token 和用户信息
      saveToken(userInfo.token);
      localStorage.setItem('uid', String(userInfo.id));
      localStorage.setItem('username', userInfo.username);
      localStorage.setItem('userCode', userInfo.userCode);

      Toast.show(translate('登錄成功'));

      setTimeout(() => {
        window.location.href = '/pc-home';
      }, 500);
    } else {
      Toast.show(res.msg || 'Google auth error');
    }
  } catch (error) {
    Toast.show('Auth error');
  }
};